import { createSelector } from 'reselect';

export const selectFlyoutCategories = state => state.flyoutCategories;
export const selectFlyoutCategoriesConfig = createSelector(
  selectFlyoutCategories,
  flyoutCategories => flyoutCategories.config,
);

export const selectFlyoutCategoriesIsLoading = createSelector(
  selectFlyoutCategories,
  flyoutCategories => flyoutCategories.isLoading,
);

export const selectFlyoutCategoriesIsLoaded = createSelector(
  selectFlyoutCategories,
  flyoutCategories => flyoutCategories.isLoaded,
);

export const selectFlyoutCategoriesCategories = createSelector(
  selectFlyoutCategories,
  flyoutCategories => flyoutCategories.categories,
);
